import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { Flex } from '../Flex';
import { Icon } from '../Icon';
import * as styles from './index.css';

type DialogProps = DialogPrimitive.DialogProps & {
    trigger?: React.ReactNode;
    title: React.ReactNode;
    children: React.ReactNode;
};

export function Dialog({ trigger, title, children, ...props }: DialogProps) {
    return (
        <DialogPrimitive.Root {...props}>
            {trigger && <DialogPrimitive.Trigger asChild>{trigger}</DialogPrimitive.Trigger>}

            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay className={styles.overlay} />
                <DialogPrimitive.Content className={styles.content}>
                    <header className={styles.header}>
                        <Flex as={DialogPrimitive.Title} className={styles.title} gap="2" align="center">
                            {title}
                        </Flex>

                        <DialogClose>
                            <button type="button" className={styles.closeButton} aria-label="Close">
                                <Icon icon={X} size="lg" />
                            </button>
                        </DialogClose>
                    </header>

                    <div className={styles.body}>{children}</div>
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
}

export function DialogClose({ children, ...props }: DialogPrimitive.DialogCloseProps) {
    return (
        <DialogPrimitive.Close asChild {...props}>
            {children}
        </DialogPrimitive.Close>
    );
}
type DialogButtonGroupProps = {
    extras?: React.ReactNode;
    children: React.ReactNode;
};

export function DialogButtonGroup({ extras, children }: DialogButtonGroupProps) {
    return (
        <Flex align="center" justify="space-between" className={styles.buttonGroup}>
            {extras}
            <Flex flex gap="2" justify="end">
                {children}
            </Flex>
        </Flex>
    );
}
